import {
  CoachPaymentKind,
  coachPaymentKindToBgColor,
  coachPaymentKindToLabel,
  coachPaymentKindToTextColor,
} from '@airreading/common/data';

interface CoachPaymentKindTagProps {
  kind: CoachPaymentKind;
  'data-testid'?: string;
}

export const CoachPaymentKindTag = (props: CoachPaymentKindTagProps) => {
  const { kind, 'data-testid': dataTestId } = props;

  return (
    <span
      style={{
        backgroundColor: coachPaymentKindToBgColor[kind],
        color: coachPaymentKindToTextColor[kind],
      }}
      className="p-1 rounded-md font-semibold"
      data-testid={dataTestId}
    >
      {coachPaymentKindToLabel[kind]}
    </span>
  );
};
